import React from 'react';

interface ProfileStepHeaderProps {
  firstName: string;
  welcome: React.ReactNode;
  completeSignup: React.ReactNode;
  step: React.ReactNode;
  completeInfo: React.ReactNode;
  stepDesc: React.ReactNode;
  children?: React.ReactNode;
}

export const ProfileStepHeader: React.FC<ProfileStepHeaderProps> = ({
  firstName,
  welcome,
  completeSignup,
  step,
  completeInfo,
  stepDesc,
  children,
}) => (
  <div className="flex w-full flex-col">
    <div>
      <div className="font-ambit text-[0.8125rem] font-[900] uppercase leading-[1.25rem] tracking-[0.0625rem] text-secondary-light md:text-[0.75rem] md:leading-[1.125rem]">
        {completeSignup}
      </div>
      <h1 className="font-ambit mt-12 break-words text-[3rem] font-[900] not-italic leading-[3.25rem] text-secondary md:mt-8 md:text-[2.5rem] md:leading-[2.75rem] lg:text-[3.5rem] lg:leading-[3.75rem] xl:text-[4.375rem] xl:leading-[4.6875rem]">
        {welcome}
      </h1>
      <h2 className="font-ambit mt-4 break-words text-[2rem] font-normal not-italic leading-[2.25rem] text-[#3B5266] md:text-[1.75rem] md:leading-[2rem] lg:text-[2.25rem] lg:leading-[2.5rem] xl:text-[2.8125rem] xl:leading-[3.125rem]">
        {firstName}
      </h2>
      <div className="font-ambit mt-9 text-[1.0625rem] font-normal not-italic leading-[1.5625rem] text-secondary md:mt-6 md:text-[0.9375rem] md:leading-[1.375rem]">
        {step}
      </div>
      <div className="font-ambit text-[1.0625rem] font-[900] not-italic leading-[1.5625rem] text-[#3B5266] md:text-[0.9375rem] md:leading-[1.375rem]">
        {completeInfo}
      </div>
      <div className="font-ambit mt-4 text-[1.0625rem] font-normal not-italic leading-[1.5625rem] text-[#3B5266] md:text-[0.9375rem] md:leading-[1.375rem]">
        {stepDesc}
      </div>
      {children}
    </div>
  </div>
);
